export const getCMPBaseUrl = (contentObjectType, contentId) => {
  return `/content-management/search/v1/${contentObjectType}/${contentId}`;
};
export const stripProtocol = url => url.replace(/^(http:\/\/)|(https:\/\/)/, '');